/** 租户层级 /metering/tenant/level（tenantLevel/index.vue + TierDialog.vue） */
export default {
  tenantLevelPage: {
    emptyNoPermission: '暂无查看权限',
    pageTitle: '层级管理',
    tipTitle: '操作说明',
    tipLine1: '• 左侧树形结构：展示组织层级关系',
    tipLine2: '• 右键菜单：创建子层级、修改、删除',
    tipLine3: '• 拖拽排序：调整层级结构',
    tipLine4: '• 绑定操作：关联租户到指定层级',
    tipText: '右键节点可进行层级操作，拖拽可调整结构',
    panelTierStructure: '层级结构',
    phSearchTier: '搜索层级',
    btnAddTier: '新增层级',
    panelOperation: '操作',
    btnBindTenants: '绑定租户',
    btnUnbindTenants: '解绑租户',
    btnConfirmOp: '确认操作',
    btnSubmitting: '处理中...',
    btnCancel: '取消',
    hintBind: '请选择要绑定的层级和租户',
    hintUnbind: '请选择要解绑的租户',
    panelUnboundTenants: '未绑定租户',
    phSearchTenant: '搜索租户',
    btnRefresh: '刷新',
    menuAddChild: '创建子层级',
    menuEdit: '修改层级',
    menuDelete: '删除层级',
    msgNoAddPerm: '暂无新增权限',
    msgNoBindPerm: '暂无绑定/解绑权限',
    msgLoadTierFail: '获取层级数据失败',
    msgLoadTierErr: '加载层级数据失败',
    msgLoadUnboundFail: '获取未绑定租户失败',
    msgLoadUnboundErr: '加载未绑定租户失败',
    msgSelectBoundTier: '请选择已绑定租户的层级',
    confirmReorder: '确认修改层级结构吗？',
    titleTip: '提示',
    btnOk: '确定',
    msgReorderOk: '层级结构修改成功',
    msgReorderFail: '层级结构修改失败',
    msgReorderErr: '修改层级结构失败',
    msgSelectTierToBind: '请选择要绑定的层级',
    msgSelectTenantToBind: '请选择要绑定的租户',
    confirmBindTitle: '确认绑定',
    confirmBindBody: '确认将 {count} 个租户绑定到选中层级吗？',
    confirmUnbindTitle: '确认解绑',
    confirmUnbindBody: '确认解绑 {count} 个租户吗？',
    msgBindOk: '租户绑定成功',
    msgBindFail: '租户绑定失败',
    msgBindErr: '绑定租户失败',
    msgUnbindOk: '租户解绑成功',
    msgUnbindFail: '租户解绑失败',
    msgUnbindErr: '解绑租户失败',
    msgSelectParentFirst: '请先选择父级层级',
    msgSelectEditTier: '请先选择要修改的层级',
    msgSelectDeleteTier: '请先选择要删除的层级',
    confirmDeleteTier: '确认删除该层级吗？删除后不可恢复！',
    titleWarn: '警告',
    msgDeleteOk: '删除成功',
    msgDeleteFail: '删除失败',
    msgDeleteErr: '删除层级失败',
    msgCannotDropOnBoundTier: '该层级已绑定租户，不能作为父级'
  },
  tierDialogPage: {
    dialogTitleAdd: '新增层级',
    dialogTitleEdit: '修改层级',
    dialogTitleAddChild: '新增子层级',
    formParentTier: '上级层级',
    phParentTier: '上级层级',
    formTierName: '层级名称',
    phTierName: '请输入层级名称',
    btnCancel: '取消',
    btnAdd: '新增',
    btnModify: '修改',
    ruleNameRequired: '请输入层级名称',
    ruleNameLen: '长度在 1 到 50 个字符',
    msgAddOk: '新增层级成功',
    msgAddFail: '新增层级失败',
    msgAddErr: '新增层级失败',
    msgUpdateOk: '更新层级成功',
    msgUpdateFail: '更新层级失败',
    msgUpdateErr: '更新层级失败'
  }
}
